import React from 'react';

import { useField } from 'formik';

export default function CheckboxFormField({ label, ...props }) {
    const [field, meta, helpers] = useField(props);
    return (
        <div className="tw-flex tw-items-center tw-space-x-1.5 input-checkbox-wrapper" key={props.key}>
            <input className={meta.touched && meta.error ? 'tw-border tw-border-red-500 input-checkbox' : 'input-checkbox'} {...field} {...props} />
            <label className="input-checkbox__label">{label}</label>
        </div>
    );
}
